<template>
  <div id="check" class="home">
    <el-container>   
      <div style="margin:80px 100px;width:100%;">
        <div class="">
          <div class="intro">
            <el-row>
              <el-col :span="6">
                <img src="../assets/images/disc_des.png" style="width:100%" alt="">
              </el-col>
              <el-col :span="16" :offset="2">
                <div style="margin-top:10px;font-size:14px;line-height:28px;text-align:justify;">DISC性格测试，是最广泛使用的测评工具之一。它在关注人的本性的同时，更加关注人的主观能动性，以及适应环境的能力;</div>
                <div style="margin-top:10px;font-size:14px;line-height:28px;text-align:justify;">DISC着重从四个方面对人进行描绘，即支配性（D）、影响性（I）、稳定性（S）和服从性（C），从而了解测试者的性格特征、管理风格、领导素质以及情绪稳定性等;</div>
                <div style="margin-top:10px;font-size:14px;line-height:28px;text-align:justify;">整个测试过程需要5-10分钟，测试者要根据自己的第一感觉，从每组四个选项中中选出最适合自己一项;</div>
              </el-col>
            </el-row>
            
          </div>
        </div>      
        <div class="content">
          <div class="qs-item" v-for="(item,index) in qs" :key="index">
            <div class="title">{{ item.title }}</div>
            <div v-for="(as,idx) in item.an" :key="idx" class="answer-box">
              <div :class="{'answer-item':true, 'active': answer[index] == as.t }"  :data-v="as.t" @click="select( index , as.t )">{{ idx+1 }}、{{ as.a }}</div>
            </div>
          </div>
          <el-button type="primary" style="width:200px;" @click="doCheck">{{ status }}</el-button>
        </div>
        <!-- 报告类型选择弹出层 -->
        <el-dialog title="选择下载类型" :visible.sync="outerVisible" :close-on-click-modal="false" :close-on-press-escape="false">
          <div style="width:100%">
            <el-row :gutter="20">
              <el-col :span="12">
                <div :class="{'cart_n':true,'cart':true,'active':downloadType == 4}" @click="handleSelect(4)">
                  <div class="title">标准版（首次免费）</div>
                  <div class="">售价￥9.8每份</div>
                </div>              
              </el-col>
              <el-col :span="12">
                <div :class="{'cart_p':true,'cart':true,'active':downloadType == 5}" @click="handleSelect(5)">
                  <div class="title">专业版</div>
                  <div class="">售价￥19.8每份</div>
                </div>
              </el-col>
            </el-row>            
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="download" :loading="loading">查看报告</el-button>
            <!-- <el-button type="primary" @click="download" :loading="loading">套餐用户下载</el-button>
            <el-button type="primary" @click="download" :loading="loading">付费用户下载</el-button> -->
          </div>
        </el-dialog>
        <!-- 报告类型选择弹出层 -->
        <!-- 报告下载 -->
        <el-dialog title="下载报告" :visible.sync="innerVisible" :close-on-click-modal="false" :close-on-press-escape="false">
          <div>
            <el-row :gutter="20">
              <el-col :span="12">
                <div>
                  <a :href="url" target="_blank" download="测评结果文件.pdf">点击下载报告</a>
                </div>
              </el-col>              
            </el-row>            
          </div>
        </el-dialog>
        <!-- 报告下载 -->
      </div>
    </el-container>
  </div>
</template>
<script>
import { fetchGet,fetchPost } from '../utils/http';
export default {
  name:'check',
  data(){
    return {
      outerVisible: false,
      innerVisible: false,
      innerHTML:{},
      status:'提交答案',
      source:'http://www.wisechoices.cn',
      downloadType:4,
      url:'',
      loading:false,
      qs:[],
      answer:["","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","",]
    }
  },
  methods:{
    select(questionNum,answerT){
      let token = sessionStorage.getItem('token');
      if(token == undefined || token == null){
        this.$message.error('登录后才能测试，请先登录或注册用户');
        setTimeout(()=>{
          return this.$router.push('/login');
        },1000)        
      }
      ////console.log(questionNum,answerT);
      //修改数组答案      
      this.$set(this.answer,questionNum, answerT);
    },
    download(){
      this.loading = true;
      let _this = this;
      fetchPost('/api/home/api/downloadDISCreport',{
        downloadType:this.downloadType,answer : this.answer,source: this.source
      }).then((res)=>{
        this.loading = false;
        if(res.data.code === 10001){
          _this.$message.error(res.data.msg);
          _this.$router.push('/login');
        }
        if(res.data.code === 10002){
          _this.$message.error(res.data.msg);
          _this.$router.push('/member-center');
        }
        if(res.data.code === 0){
          return _this.$message.error(res.data.msg);        
        }
        if(res.data.code === 1){
          if(res.data.data.status == 2000){
            var newWin = window.open("","_blank");
            newWin.document.body.innerHTML = res.data.data.form;
            newWin.document.forms[0].submit();
            return;
          }
          if(res.data.data.status == undefined){
            _this.url = res.data.data;
            _this.innerVisible = true;           
          }
        }
      });
    },
    doCheck(){
      if( this.answer.includes("") ){
        return this.$message.error('还有题目未选择，请先做完所有测试题');
      }
      this.outerVisible = true;      
      
      // var a = document.createElement('a');
      // a.setAttribute('href', res.data.data);
      // a.setAttribute('target', '_blank');
      // a.setAttribute('id', 'startTelMedicine');
      // // 防止反复添加
      // if(document.getElementById('startTelMedicine')) {
      //   document.body.removeChild(document.getElementById('startTelMedicine'));
      // }
      // document.body.appendChild(a);
      // a.click();
    },
    handleSelect(index){
      this.downloadType = index;
    },
    init(){      
      let qs = [
        {title:'一、整体上讲，我是一个： [单选题]',an:[{a:'勤劳的人，不停地工作，尽快完成任务，不愿意休息；',t:"D"},{a:'活力充沛的人，总是充满活力，精力充沛，不停地动；',t:'I'},{a:'和气的人，易相处，易说话，易让人接近；',t:'S'},{a:'完美主义者，对自己、对别人都有高标准，希望事物都要有秩序。',t:'C'}]},
        {title:'二、生活中，我总是表现得： [单选题]',an:[{a:'生机勃勃，对生活充满热情与兴奋；',t:'I'},{a:'满足现状，容易接受任何情况与环境；',t:'S'},{a:'谨小慎微，对周围的人和事过分关心和敏感；',t:'C'},{a:'不断进取，不满足现状，希望推动改变。',t:'D'}]},
        {title:'三、我觉得我自己属于： [单选题]',an:[{a:'适应性强，能轻松自如地适应任何环境的人；',t:'S'},{a:'善于分析，喜欢研究事物之间逻辑关系的人；',t:'C'},{a:'喜欢挑战，愿意面对新事物并敢于下决心掌握的人；',t:'D'},{a:'让人开心，喜欢与他人相处，充满乐趣的人。',t:'I'}]},
        {title:'四、对于任务，我愿意做： [单选题]',an:[{a:'计划者，先做详尽的计划，再严格按照计划执行，不想改动；',t:'C'},{a:'指挥者，身先士卒，指挥和带领他人一起干；',t:'D'},{a:'发起者，动用性格魅力来发动和鼓励别人参与；',t:'I'},{a:'跟随者，启动虽慢，但是愿意跟随他人持续干下去。',t:'S'}]},
        {title:'五、与人相处中，我是一个： [单选题]',an:[{a:'善于说服的人，用事实结合威严和权力让人听从；',t:'D'},{a:'使人振作的人，给他人清新、振奋的刺激，激励他人振作；',t:'I'},{a:'重视收集信息，善于逻辑分析；',t:'C'},{a:'体贴他人的人，关心别人的感受与需要。',t:'S'}]},
        {title:'六、生活中，我通常： [单选题]',an:[{a:'尊重他人，常常为别人着想；',t:'S'},{a:'情绪稳定，善于控制自己的情感，极少流露；',t:'C'},{a:'喜好娱乐，常常开心，充满乐趣与幽默感；',t:'I'},{a:'善于应变，对新情况都能做出有效的反应。',t:'D'}]},
        {title:'七、我日常的表现是： [单选题]',an:[{a:'稳定平和，在冲突中能不受干扰，保持平静；',t:'S'},{a:'善始善终，要完成现有的事才能做新的事情；',t:'C'},{a:'喜欢竞争，把一切当成竞赛，总是有强烈的赢的欲望；',t:'D'},{a:'积极参与，总是最快的参与到新活动中去。',t:'I'}]},
        {title:'八、面对新事物，我： [单选题]',an:[{a:'注意细节，观察入微，发现新的信号和情况；',t:'C'},{a:'敢于冒险，无所畏惧、喜欢挑战新事物；',t:'D'},{a:'充满好奇，跃跃欲试，积极的参与；',t:'I'},{a:'安于现状，不太理会新事物。',t:'S'}]},
        {title:'九、有人评价我： [单选题]',an:[{a:'很自信，确信个人的能力与成功，很少有犹豫或者动摇的情形；',t:'D'},{a:'充满活力，并将快乐传于他人；',t:'I'},{a:'情绪平稳，没有大的起伏变化；',t:'S'},{a:'有文化修养，对艺术、学术(如戏剧、交响乐、文学)特别爱好。',t:'C'}]},
        {title:'十、与人相处，我属于： [单选题]',an:[{a:'有趣的人，风趣、幽默，把任何事物都能变成精彩的故事；',t:'I'},{a:'权威的人，总是发号施令，让他人听从；',t:'D'},{a:'忠诚的人，一贯可靠，忠贞不渝，一旦认同就很难放弃；',t:'C'},{a:'友善的人，虽然不主动交谈，但是也不爱争论。',t:'S'}]},
        {title:'十一、对于规则，我是： [单选题]',an:[{a:'遵守者，严格遵守并认真执行，虽然对规则并不完全赞同；',t:'S'},{a:'制定者，常常制定规则，以身作则，并希望人人都按规则办事；',t:'C'},{a:'破坏者，破坏规则，不愿意让自己受到任何约束；',t:'D'},{a:'变化者，时而遵守，时而挑战，要看具体情况。',t:'I'}]},
        {title:'十二、好朋友经常评价我是一个： [单选题]',an:[{a:'追求完美的人，总是希望把所有的事情做到完美无缺；',t:'C'},{a:'意志坚定的人，决心以自己的方式做事而不管他人的意见；',t:'D'},{a:'善于社交的人，友谊第一，认为与人相处是乐趣，而不是挑战；',t:'I'},{a:'与人为善的人，易接受他人的观点和喜好，不坚持己见。',t:'S'}]},
        {title:'十三、生活中，我会： [单选题]',an:[{a:'重视他人感受，尽量不说或者做可能引起别人不满和反对的事情；',t:'S'},{a:'积极相应，并鼓励别人参与、加入，并把每件事情变得有趣；',t:'I'},{a:'讲究规律性，生活处事依靠时间表，不喜欢计划被干扰；',t:'C'},{a:'自给自足，独立自信，不需要他人帮忙。',t:'D'}]},
        {title:'十四、人际交往中，好朋友说我是一个： [单选题]',an:[{a:'受欢迎的人，聚会时的灵魂人物，受欢迎的宾客；',t:'I'},{a:'和气的人，给人舒适感，让人放松；',t:'S'},{a:'忠心的人，对理想、朋友、工作都很忠实，一旦认同就不容易改变；',t:'C'},{a:'强势的人，各个方面总是显得比别人强。',t:'D'}]},
        {title:'十五、我的思维具有： [单选题]',an:[{a:'平衡性，讲究平衡，稳定，走中间路线；',t:'S'},{a:'规范性，时时坚持自己的举止合乎认同的规范；',t:'C'},{a:'进取性，无所畏惧，大胆前进，不怕冒险；',t:'D'},{a:'跳跃性，充满活力，变化很快，总显得生气勃勃。',t:'I'}]},
        {title:'十六、生活中，我总是： [单选题]',an:[{a:'考虑周到，善解人意，帮助别人，总能记住特别的日子；',t:'S'},{a:'自信而执着，不达目的誓不罢休；',t:'D'},{a:'不断地说话，喜欢讲笑话以娱乐他人，觉得应该尽量打破沉默而避免尴尬；',t:'I'},{a:'易迁就，改变自己以与他人协调，短时间内按他人要求行事。',t:'C'}]},
        {title:'十七、我感觉自己是一个： [单选题]',an:[{a:'果断的人，总是很快做出判断与结论；',t:'D'},{a:'情绪外露的人，从不掩饰情感、喜好、交谈时常身不由己接触他人；',t:'I'},{a:'含蓄的人，自我约束情绪，不轻易发表自己的看法；',t:'S'},{a:'深沉的人，深刻并常常内省，厌恶肤浅的交谈、消遣。',t:'C'}]},
        {title:'十八、面对任务，我通常是： [单选题]',an:[{a:'积极响应，只要受人喜爱，成为人们注意的中心，就可以行动；',t:'I'},{a:'看看再说，不用着急，先看看情况，做好准备；',t:'S'},{a:'三思而后行，井井有条的，有系统有条理安排事情；',t:'C'},{a:'立即行动，只有行动才能完成任务。',t:'D'}]},
        {title:'十九、讨论中，我通常： [单选题]',an:[{a:'显得宽容，易接受别人的想法和看法，不需要反对或改变他人；',t:'S'},{a:'讲究数据说服，善于用图表数字来组织工作，阐述思想和解决问题；',t:'C'},{a:'很乐观，鼓励大家要积极向上，快速采取行动；',t:'I'},{a:'积极主动，抓住机会，毫无保留，坦率发言。',t:'D'}]},
        {title:'二十、我愿意充当： [单选题]',an:[{a:'规划者，以自己完美的标准来设想、衡量和规划事物；',t:'C'},{a:'推动者，推动事物高效发展，是别人的领导者，闲不住；',t:'D'},{a:'社交者，喜欢周旋在聚会中，能很快把陌生人交成好朋友；',t:'I'},{a:'调解者，经常居中调节不同的意见，以避免双方的冲突。',t:'S'}]},
        {title:'二十一、最熟悉的人，有时会说我是一个： [单选题]',an:[{a:'不善交际的人，总喜欢挑人毛病，不受人喜欢；',t:'C'},{a:'冷漠的人，漠不关心，得过且过，不太有热情；',t:'S'},{a:'天真的人，孩子般的单纯，不理解生命的真谛，永远长不大；',t:'I'},{a:'工作狂，为了回报或成就感，设立宏伟目标不断工作，耻于休息。',t:'D'}]},
        {title:'二十二、如果有人询问意见，我会： [单选题]',an:[{a:'热情洋溢、滔滔不绝地把自己的意见阐述出来；',t:'I'},{a:'言简意赅，直接表达自己的意见；',t:'D'},{a:'不愿意直接表达意见，表示尊重对方的意见；',t:'S'},{a:'先猜测对方的真实意图，再逻辑清楚的表达自己的意见。',t:'C'}]},
        {title:'二十三、如果有人不同意我的观点，我通常的做法是： [单选题]',an:[{a:'平静的倾听他人的想法，尽量避免冲突；',t:'S'},{a:'运用沟通技巧，利用个性的魅力吸引他人，让他们同意我的观点；',t:'I'},{a:'运用逻辑，数据有条理的改变他人的观点；',t:'C'},{a:'积极的反驳他人的观点，用强力改变对方，从而接受我的观点。',t:'D'}]},
        {title:'二十四、我希望有这样的机会： [单选题]',an:[{a:'影响和吸引他人的机会；',t:'I'},{a:'不断修正，走向完美的机会；',t:'C'},{a:'改变世界，控制事物的机会；',t:'D'},{a:'放松、休息的机会。',t:'S'}]},
        {title:'二十五、对于工作计划，我是这么看待的： [单选题]',an:[{a:'计划虽然有用，但更重要的是行动，结果才是最重要的；',t:'D'},{a:'最好不要有什么计划，太多的约束会缺乏新意；',t:'I'},{a:'有无计划都行，只要别弄得太复杂；',t:'S'},{a:'必须要有计划，而且需要严格地遵循计划。',t:'C'}]},
        {title:'二十六、面对规则，我属于： [单选题]',an:[{a:'规则的执行者，虽然不一定认同，但还是会遵守；',t:'S'},{a:'规则的制定者，也是以身作则的遵守者；',t:'C'},{a:'规则的改变者，总是想方设法不断地调整和改变规则；',t:'I'},{a:'规则的破坏者，反感收到约束，总是去挑战和破坏自己不认同的规则。',t:'D'}]},
        {title:'二十七、聚会中，我显得： [单选题]',an:[{a:'有些孤僻，需要大量的时间独处，避开人群，思考自己的事情；',t:'C'},{a:'有统治欲，毫不犹豫地展示自己的控制能力，以展示自己的独到之处；',t:'D'},{a:'沉默，不太喜欢参与，显得有些不太热情；',t:'S'},{a:'嗓门大，说话声和笑声总盖过他人，希望成为大家关注的焦点。',t:'I'}]},
        {title:'二十八、如果必须获得某些资源，我通常会怎么做？ [单选题]',an:[{a:'恳请对方支持，并提出替代方案，以免为难对方；',t:'S'},{a:'运用严密的逻辑，详细的数据来说明情况，以获取支持；',t:'C'},{a:'运用个性魅力，拉近关系以获取对方的支持；',t:'I'},{a:'告诉对方，如果不能满足会带来什么负面后果，从而迫使对方答应。',t:'D'}]},
        {title:'二十九、我比较反感的情形是： [单选题]',an:[{a:'粗心大意，不注重细节的人；',t:'C'},{a:'沉闷、死板，生活没有情趣的人；',t:'I'},{a:'冲动，反应太过于激烈的人；',t:'S'},{a:'动作迟缓，反应慢，懒惰的人。',t:'D'}]},
        {title:'三十、在指导对方时，我通常的做法是： [单选题]',an:[{a:'友好的提出操作方法，并和对方共同完成；',t:'S'},{a:'直接切入要点，要求对方遵照执行；',t:'D'},{a:'运用数据、流程，非常细致和严格地要求对方；',t:'C'},{a:'热情有好，并且采用大量的身体语言让其他人参与。',t:'I'}]},
        {title:'三十一、有熟悉的人认为，我是一个： [单选题]',an:[{a:'固执的人，坚持按照自己的意见行事，不听不同意见；',t:'D'},{a:'行动迟缓的人，迟迟才有行动，不易参与；',t:'S'},{a:'随兴的人，做事情没有一贯性，随意做事情；',t:'I'},{a:'难于取悦的人，因为要求太高而使别人很难取悦。',t:'C'}]},
        {title:'三十二、如果不同意对方的观点，我会： [单选题]',an:[{a:'热情、友好的向对方直接提出我的看法；',t:'I'},{a:'直接指出对方的错误所在，并提出自己的观点；',t:'D'},{a:'理解和尊重对方的观点，委婉地提出自己的观点；',t:'S'},{a:'详细地分析和阐述对方观点的错误所在。',t:'C'}]},
        {title:'三十三、下面最能形容我的风格是： [单选题]',an:[{a:'做:行动才能解决问题；',t:'D'},{a:'想：三思而后行；',t:'C'},{a:'看：旁观者清；',t:'S'},{a:'说：畅所欲言。',t:'I'}]},
        {title:'三十四、我对于自己不够满意的地方是： [单选题]',an:[{a:'挑剔，太注重琐事细节，总是喜欢挑不足；',t:'C'},{a:'胆小，面对不同的意见和冲突，总是采取躲避和退让的方式；',t:'S'},{a:'健忘，缺乏自我约束，导致健忘，不愿意记无趣的事情；',t:'I'},{a:'率直，直言不讳，直接表达自己的看法而不管他人的感受。',t:'D'}]},
        {title:'三十五、对于合作，我通常： [单选题]',an:[{a:'采取中间路线，无高低之分，很少表露个人倾向；',t:'S'},{a:'自我评价高，认为自己是最好的人选；',t:'D'},{a:'总看到危机，尽管期待最好但往往首先看到不利之处；',t:'C'},{a:'允许别人做他喜欢做的事情，为的是讨好别人。',t:'I'}]},
        {title:'三十六、生活中，我有时也有这样的情形： [单选题]',an:[{a:'有些消极，往往看到事物的消极面，黑暗面；',t:'C'},{a:'喜获认同，需要旁人认同赞赏，想演员一样得到鲜花和欢呼，',t:'I'},{a:'缺乏同情心，很难用语言和动作当众表达情感，尤其是同情心，',t:'D'},{a:'很乏味，凡事总是提不起兴奋和热情，不想参与和投入。',t:'S'}]},
        {title:'三十七、我最欣赏这样的人： [单选题]',an:[{a:'做事严谨，在乎细节，思路清晰；',t:'C'},{a:'心地善良，宽容，有耐心；',t:'S'},{a:'活泼，友好，总是给人带来快乐；',t:'I'},{a:'果敢，自信，敢说敢当。',t:'D'}]},
        {title:'三十八、对于业余爱好，我最符合的是： [单选题]',an:[{a:'没有什么特别的爱好，能让人放松就行；',t:'S'},{a:'爱好不多，但做得还行；',t:'C'},{a:'喜欢能对工作带来帮助、有意义的项目；',t:'D'},{a:'爱好太多了，玩得都挺好。',t:'I'}]},
        {title:'三十九、看到有人做得不对的地方，我会： [单选题]',an:[{a:'又说又做，即指责对方的不足，同时又帮助对方调整和改变；',t:'C'},{a:'不说不做，不需要太着急参与，给对方留足够的调整时间和成长空间；',t:'S'},{a:'多说少做，主要是在语言上给对方更多的指导，不一定采取行动；',t:'I'},{a:'少说多做，不需要过多的语言，直接帮助对方改正错误。',t:'D'}]},
        {title:'四十、我最认同的关于使命的说法是： [单选题]',an:[{a:'用我的意志改变世界；',t:'D'},{a:'用我的魅力给世界带来快乐；',t:'I'},{a:'用我的牺牲给世界带来和平；',t:'S'},{a:'用我的付出让世界更美好。',t:'C'}]}      
      ]
      this.qs = qs;
    }
  },
  mounted(){
    this.init();    
  }
}
</script>
<style scoped>
.home{
  background-color: #f4f4f4;
  width: 100%;
}
.content{
  background-color: #ffffff;
  padding: 50px 80px;
}
.qs-item{
  margin-bottom: 30px;
}
.title{
  font-size: 14px;
  padding-bottom: 10px;
}
.answer-item{
  font-size: 14px;
  color: #777;
  margin-bottom: 4px;
  cursor: pointer;
  padding: 8px 12px;
  width: 500px;
}
.answer-box{
  margin-left: 24px;
}
.answer-item:hover{
  background-color: #05A4C2;
  color: #ffffff;
}
.active{
  background-color: #05A4C2;
  color: #ffffff;
}
.intro{
  font-size: 14px;
  text-align: justify;
  color: #888;
  line-height: 2;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 30px 50px;
  margin-bottom: 20px;
}
.cart{
  width: 100%;
  height: 120px;
  background-color: #05A4C2;
  border-radius: 10px;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.cart .title{
  padding-top: 35px;
  font-size: 14px;
  font-weight: bold;
}
.active{
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6);
  border: 1px dashed #ffffff;
}
.explain{
  margin: 50px 30px 30px 30px;  
}
</style>
